export function contactsForm(){
    const holderForm = document.querySelector('.holder-wpcf7');
    const form = document.querySelector('.wpcf7-form');
    const thanksBox = document.querySelector('.thanks-box');

    $(form).find('.wpcf7-form-control-wrap input, .wpcf7-form-control-wrap textarea, .wpcf7-form-control-wrap select').focus(function () {
        $(this).closest('.form-item').addClass('focused');

    }).blur(function () {
        $(this).closest('.form-item').removeClass('focused');

        if (!$(this).val()) {
            $(this).closest('.form-item').removeClass('not-empty');
        } else {
            $(this).closest('.form-item').addClass('not-empty');
        }
    });

    form.addEventListener( 'wpcf7mailsent', function( event ) {
        thanksBox.style.display = 'block';
        holderForm.style.display = 'none';

        form.reset();
        $(form).find('.form-item').removeClass('not-empty');
    }, false );

    $('a.show-form').on('click',function (e) {
        e.preventDefault();

        thanksBox.style.display = 'none';
        holderForm.style.display = 'block';
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contactsForm.js